<template>
<Row type="flex" justify="end"  align="middle">
    <Col v-show="showHelpBtn">
        <Button style="width:100px" size="small" icon="md-help-circle" type="text" @click="openHelp">帮助中心</Button>
    </Col>
    <Col v-if="modulecodeFlag">
        <Button  size="small" style="margin-left:15px" type="text">{{modulecode}}</Button>
    </Col>
</Row>
</template>

<script>
export default {
    name:'promptmessage',
    data() {
        return {
            modulecodeFlag:false,
            modulecode:'',
            showHelpBtn:false,
            curHelpUrl:''
        };
    },
    created () {
        // 处理模块号提示
        this.modulecode = this.$Method.getUrlParam('modulecode');
        if (!this.modulecode) {
            this.modulecode = this.$Method.getUrlParam('billmoduleid');
        }
        if (this.modulecode) {
            this.modulecodeFlag = true;
        }
        //处理帮助
        let self = this;
        this.curHelpUrl = this.OmdUrl.getCurHelpUrl(self);
        if (this.curHelpUrl) {
            this.showHelpBtn = true;
        }
    },
    methods:{
        openHelp () {
            if (this.curHelpUrl) {
                window.open(this.curHelpUrl);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/promptmessage.vue